import i18n from "../i18n";

export const isRTL = () => {
  const rtlLanguages = ["ar"];
  return rtlLanguages.includes(i18n.language);
};
